module.exports = __webpack_public_path__ + "img/SketchPng785547c0c0c1befa915bbaec8efc2bb8b72473fffe89434ec489d25f9b8e8237.7cc61f38.png";